module.exports = __webpack_public_path__ + "static/media/PAE.fcd35571.svg";